import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 0,
    lpSymbol: 'ORI',
    lpAddresses: {
      97: '0xC5FD6F3eB1f63082Daee9e09E17D870005962309',
      250: '0x0575f8738EFdA7F512e3654F277C77e80C7d2725',
    },
    tokenSymbol: 'MECHS',
    tokenAddresses: {
      97: '0xC5FD6F3eB1f63082Daee9e09E17D870005962309',
      250: '0x0575f8738EFdA7F512e3654F277C77e80C7d2725',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 1,
    lpSymbol: 'ORI-FTM',
    lpAddresses: {
      97: '',
      250: '0x0433305Ae161d28eD1408D11581610339dfC9BE4',
    },
    tokenSymbol: 'ORI',
    tokenAddresses: {
      97: '',
      250: '0x0575f8738EFdA7F512e3654F277C77e80C7d2725',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 2,
    lpSymbol: 'AURORA-FTM',
    lpAddresses: {
      97: '',
      250: '0x483d07bc99cdd1df66f64ae0a769a70725c46fa4',
    },
    tokenSymbol: 'AURORA',
    tokenAddresses: {
      97: '',
      250: '0xbc2451AaD349b6B43FD05F4F0cC327F8A6bcA2d4',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 8,
    lpSymbol: 'ORI-USDC',
    lpAddresses: {
      97: '',
      250: '0xF70a9Af9f581c2F752Acc779148712c43E58d2f0',
    },
    tokenSymbol: 'ORI',
    tokenAddresses: {
      97: '',
      250: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    },
    quoteTokenSymbol: QuoteToken.ORI,
    quoteTokenAdresses: contracts.ori,
  },
  {
    pid: 3,
    lpSymbol: 'USDC-FTM',
    lpAddresses: {
      97: '',
      250: '0x50cc648e45b84d68405ba0707e94c507b08e593d',
    },
    tokenSymbol: 'USDC',
    tokenAddresses: {
      97: '',
      250: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 4,
    lpSymbol: 'ETH-FTM',
    lpAddresses: {
      97: '',
      250: '0xc81a9ce5be68df6a52f82d83398420d8a1c245c2',
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '',
      250: '0x74b23882a30290451a17c44f4f05243b6b58c76d',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 5,
    lpSymbol: 'BTC-FTM',
    lpAddresses: {
      97: '',
      250: '0x9a2b08b7620b8c387d96f9c1dc315afd93651f5e',
    },
    tokenSymbol: 'BTC',
    tokenAddresses: {
      97: '',
      250: '0x321162cd933e2be498cd2267a90534a804051b11',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 6,
    lpSymbol: 'LINK-FTM',
    lpAddresses: {
      97: '',
      250: '0x442beca06141f99466d288bde60e79330ecbdf51',
    },
    tokenSymbol: 'LINK',
    tokenAddresses: {
      97: '',
      250: '0xb3654dc3d10ea7645f8319668e8f54d2574fbdc8',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 7,
    lpSymbol: 'DAI-FTM',
    lpAddresses: {
      97: '',
      250: '0x6d898d98818e670c695e374ed77cd1753cf109dd',
    },
    tokenSymbol: 'DAI',
    tokenAddresses: {
      97: '',
      250: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
    },
    quoteTokenSymbol: QuoteToken.FTM,
    quoteTokenAdresses: contracts.wbnb,
  },
]

export default farms
